import { useAuthStore } from '../store/authStore';
import { Organization } from '../types/organization';
import { Site } from '../types/auth';

/**
 * Hook to provide organization-related data from the auth store
 */
export interface UseOrganizationResult {
  currentOrganizationId: number | undefined;
  organizationName: string | undefined;
  organizationData: Organization | undefined;
  currentSite: Site | undefined;
  userSites: Site[] | undefined;
}

/**
 * Custom hook to access organization data from the auth store
 */
export const useOrganization = (): UseOrganizationResult => {
  const userOrgId = useAuthStore((state) => state.userOrgId);
  const user = useAuthStore((state) => state.user);
  
  // Get the first site as the default site
  const defaultSite = user?.sites && user.sites.length > 0 ? user.sites[0] : undefined;
  
  return {
    currentOrganizationId: userOrgId ?? undefined,
    organizationName: user?.organization?.name,
    organizationData: user?.organization,
    currentSite: defaultSite,
    userSites: user?.sites,
  };
}; 